import { createPrefixer } from '@mews-framework/redux';

export const MODULE_NAME = 'globalization';

interface WithGlobalization<G> {
    globalization: G;
}

export const prefix = createPrefixer(MODULE_NAME);
export const moduleSelector = <S extends WithGlobalization<G>, G>(state: S): G => state[MODULE_NAME];
